import React, { Fragment, Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { /*GlgSelect,*/ GlgButton } from 'SharedComponents'
import ChangeImagePopup from './change_image_popup'
import PropTypes from 'prop-types'
import { NONE } from '../constants'

class GeneralComponent extends Component {
  render(){
    const {
      backgroundImage,
    } = this.props

    return (
      <Fragment>
        <Row>
          <Col className='subsection_name no-padding-left no-margin-top' xs={ 12 }>
            { !window.I18n ? '' : window.I18n.t('tv_shows.components.general_component.background') }
          </Col>
        </Row>
        <Row className='vertical-align-items'>
          <Col className='no-padding-left' xs={ 12 } lg={ 2 }>
            <div className='background-container'>
              {backgroundImage === NONE ? (
                !window.I18n ? '' : window.I18n.t('tv_shows.components.general_component.none')
              ) : (
                <img src={ backgroundImage } />
              )}
            </div>
          </Col>
          <Col className='no-padding-left' xs={ 12 } lg={ 1 }>
            <GlgButton
              text={ !window.I18n ? '' : window.I18n.t('tv_shows.components.general_component.change') }
              color="white"
              size="small"
              onClick={ () => { this.props.setPopupProperty('backgroundImage', 'show', true) } } />
          </Col>
        </Row>
        <ChangeImagePopup
          { ...this.props.popups.backgroundImage }
          showNone={ true }
          fetchImagesPath={ this.props.paths.fetchBackgroundImagesLinks }
          uploadImagePath={ this.props.paths.uploadBackgroundImage }
          updateImageTitlePath={ this.props.paths.updateBackgroundImageTitle }
          setImage={ this.props.setBackground }
          onClose={ () => { this.props.setPopupProperty('backgroundImage', 'show', false) } } />
      </Fragment>
    )
  }
}

GeneralComponent.propTypes = {
  paths: PropTypes.object.isRequired,
  sponsorLogos: PropTypes.arrayOf(PropTypes.string).isRequired,
  backgroundImage: PropTypes.string.isRequired,
  popups: PropTypes.object.isRequired,
  setPopupProperty: PropTypes.func.isRequired,
  setBackground: PropTypes.func.isRequired,
}

export default GeneralComponent
